import emailImg from 'assets/images/EmailSquare.svg';
import noteImg from 'assets/images/channel-note.svg';
import smsImg from 'assets/images/SmsSquare.svg';
import whatsappImg from 'assets/images/WhatsappSquare.svg';
import webChatImg from 'assets/images/WebChatSquare.svg';

export enum ChannelType {
    Sms = 'sms',
    Whatsapp = 'whatsapp',
    Email = 'email',
    WebChat = 'web_chat',
}

export const getChannelImage = (channel: ChannelType): string => {
    switch (channel) {
        case ChannelType.Whatsapp:
            return whatsappImg;
        case ChannelType.Email:
            return emailImg;
        case ChannelType.Sms:
            return smsImg;
        case ChannelType.WebChat:
            return webChatImg;
        default:
            return noteImg;
    }
};

export const getInboxChannelDisplayName = (channel: ChannelType): string => {
    switch (channel) {
        case ChannelType.Whatsapp:
            return 'WhatsApp';
        case ChannelType.Email:
            return 'Email';
        case ChannelType.Sms:
            return 'SMS';
        case ChannelType.WebChat:
            return 'Web chat';
        default:
            return 'Inbox';
    }
};
